import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=2c5d1891&"
import script from "./Sales.vue?vue&type=script&lang=ts&"
export * from "./Sales.vue?vue&type=script&lang=ts&"
import style0 from "./Sales.vue?vue&type=style&index=0&id=2c5d1891&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports